(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
    $('.ultimate_container').on('beforeChange', function(event, slick, currentSlide) {
    if ($(slick.$slides[currentSlide]).hasClass('slick-current')) {
        $(this).closest('.ultimate_purpose').removeClass('page-width');
    }
  });
        $('.ultimate_container').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2500,
        speed: 700,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false
            }
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              centerMode: false
            }
          }
        ]
      });


       $('.ultimate_cstm_slider').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      speed: 700,
      arrows:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-faq"] && !Shopify.designMode) return;
  try {
    
  // var getproducttab = document.querySelectorAll('.product_details');
  // getproducttab.forEach((item) => {
  //   let title = item.querySelector('.metatitle_svg');
  //   let faqIconPlus = item.querySelector('.metatitle_svg .plus-icon');
  //   let faqIconMinus = item.querySelector('.metatitle_svg .minus-icon');
  //   let content = item.querySelector('.metaContent');
  //   title.addEventListener("click", function() {
  //     if (!content.classList.contains('hideElement')) {
  //       content.classList.add('hideElement');
  //        faqIconPlus.style.display="block";
  //       faqIconMinus.style.display="none"
  //     } else {
  //       getproducttab.forEach((otherItem) => {
  //         if (otherItem !== item) {
  //           otherItem.querySelector('.metaContent').classList.add('hideElement');
  //            let otherPlusIcon = otherItem.querySelector('.metatitle_svg .plus-icon');
  //            let otherMinusIcon = otherItem.querySelector('.metatitle_svg .minus-icon');
  //             otherPlusIcon.style.display="block";
  //             otherMinusIcon.style.display="none";
  //         }
  //       });
  //       content.classList.remove('hideElement');
  //       faqIconPlus.style.display="none";
  //       faqIconMinus.style.display="block"
  //       console.log(faqIcon,"faqIcon")
  //     }
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-faq"] && !Shopify.designMode) return;
  try {
    
  var getproducttab = document.querySelectorAll('.product_details');
  getproducttab.forEach((item) => {
    let title = item.querySelector('.metatitle_svg');
    let faqIconPlus = item.querySelector('.metatitle_svg .plus-icon');
    let faqIconMinus = item.querySelector('.metatitle_svg .minus-icon');
    let content = item.querySelector('.metaContent');
    title.addEventListener("click", function() {
      if (!content.classList.contains('hideElement')) {
        content.classList.add('hideElement');
         faqIconPlus.style.display="block";
        faqIconMinus.style.display="none"
      } else {
        getproducttab.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.querySelector('.metaContent').classList.add('hideElement');
             let otherPlusIcon = otherItem.querySelector('.metatitle_svg .plus-icon');
             let otherMinusIcon = otherItem.querySelector('.metatitle_svg .minus-icon');
              otherPlusIcon.style.display="block";
              otherMinusIcon.style.display="none";
          }
        });
        content.classList.remove('hideElement');
        faqIconPlus.style.display="none";
        faqIconMinus.style.display="block"
        console.log(faqIcon,"faqIcon")
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["way-to-consume"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.main-container-consume-accordion-inner');
    function closeAllAnswers() {
      accordionItems.forEach(item => {
        const answer = item.querySelector('.consumer-answer'); answer.style.display = 'none';
        item.querySelector('.consume-question').classList.remove('active');
      });
    }
    function openAnswer(item) {
      const answer = item.querySelector('.consumer-answer');
      answer.style.display = 'block';
      item.querySelector('.consume-question').classList.add('active');
    }
    if(accordionItems.length > 0) {
      openAnswer(accordionItems[0]);
    }
    accordionItems.forEach(item => {
      const question = item.querySelector('.consume-question');
      question.addEventListener('click', function() {

        closeAllAnswers();
        openAnswer(item);
      });
    });
  });
 $(document).ready(function(){
    $(".consume-question").eq(1).click(function(){
        let colorCode = $(this).attr("color");
        $(this).css("border-top", `1px solid ${colorCode}`); // Use template literal for dynamic color
        $(".consumer-answer").css("border-bottom", "none");
        $(this).css("padding-top", "11px");
    });
});

  } catch(e) { console.error(e); }
})();
})();
